
import {
  CliLinkSessionPostRequest,
  CliLinkSessionPostResponse,
} from '@flagsync/skyline';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { sky } from '@/services/api-client';
import { ServiceError } from '@/services/utils/service-error';

export interface LinkCliSessionVariables {
  code: string;
}

export function useLinkCliSession(
  options?: UseMutationOptions<
    CliLinkSessionPostResponse,
    ServiceError,
    LinkCliSessionVariables
  >,
) {
  return useMutation<
    CliLinkSessionPostResponse,
    ServiceError,
    LinkCliSessionVariables
  >({
    mutationFn: (variables) => {
      const request: CliLinkSessionPostRequest = { code: variables.code };
      return sky.post<CliLinkSessionPostResponse>('/cli/link', request);
    },
    ...options,
  });
}
